import React from 'react';
import { connect, Dispatch } from 'react-redux';

import Carousel, { IDisplayProps } from 'components/global/application/Carousel';
import { ICarouselAction, ICarouselUnit, leftArrow, register, rightArrow, unregister } from 'redux/modules/carousel';

import { IRootState } from 'redux/root_reducer';

interface IDataProps {
    name: string;
    children: React.ReactNode;
}

const mapStateToProps = (state: IRootState, ownProps: IDataProps): Partial<IDisplayProps> => {
    const currentCarousel = state.carousel.carousels.find((v: ICarouselUnit): boolean => v.name === ownProps.name);
    return {
        activeItem: currentCarousel ? currentCarousel.active_slide : 0
    };
};

const mapDispatchToProps = (dispatch: Dispatch<ICarouselAction>, ownProps: IDataProps): Partial<IDisplayProps> => {
    return{
        didMount: () => dispatch<ICarouselAction>(register(ownProps.name, React.Children.count(ownProps.children))),
        leftArrowClicked: () => dispatch<ICarouselAction>(leftArrow(ownProps.name)),
        rightArrowClicked:  () => dispatch<ICarouselAction>(rightArrow(ownProps.name)),
        willUnMount: () => dispatch<ICarouselAction>(unregister(ownProps.name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Carousel);



// WEBPACK FOOTER //
// ./src/containers/global/application/Carousel.tsx